import { PdfInfo } from "PdfInfo";
export class SettlementPriceYearList {
    Year: number;
    PdfInfos: PdfInfo[];
    constructor(year: number, pdfInfos: PdfInfo[]) {
        this.Year = year;
        this.PdfInfos = pdfInfos;
    }
}